import { render, staticRenderFns } from "./TokensManager.vue?vue&type=template&id=5c9cf0fb"
import script from "./TokensManager.vue?vue&type=script&lang=js"
export * from "./TokensManager.vue?vue&type=script&lang=js"
import style0 from "./TokensManager.vue?vue&type=style&index=0&id=5c9cf0fb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports